import { BaseModel } from '../../_base/crud';

export class ContactRelationshipAgreementModel extends BaseModel {
  id: number;
  status: string;
  signing_provider_id: string;
  signing_provider_name: string;
  signing_provider_document_id: string;
  date_sent: Date;
  date_signed: Date;
  start_date: Date;
  end_date: Date;
  void_date: Date;

  clear() {
    this.id = 0;
    this.status = '';
    this.signing_provider_id = '';
    this.signing_provider_name = '';
    this.signing_provider_document_id = '';
    this.date_sent = undefined;
    this.date_signed = undefined;
    this.start_date = undefined;
    this.end_date = undefined;
    this.void_date = undefined;
  }
}
